import React from "react";

/**
 * Big circular progress ring for the wallboard daily goal.
 * Color shifts from red → amber → emerald as % climbs.
 */
export default function GoalRing({ current, target, size = 200, stroke = 14 }) {
  const pct = Math.min(100, Math.round(((current || 0) / Math.max(1, target)) * 100));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const color = pct >= 100 ? "#10B981" : pct >= 50 ? "#F59E0B" : "#C8102E";

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid="goal-ring"
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.6s ease, stroke 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-500">Goal</div>
        <div className="font-heading font-black text-5xl tabular-nums leading-none mt-1" style={{ color }}>
          {pct}%
        </div>
        <div className="text-xs font-mono text-zinc-400 mt-1.5 tabular-nums">
          {current} / {target}
        </div>
      </div>
    </div>
  );
}
